/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagCreateRequest
 */
export interface TagCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TagCreateRequest
     */
    tagName?: string | null;
}

export function TagCreateRequestFromJSON(json: any): TagCreateRequest {
    return TagCreateRequestFromJSONTyped(json, false);
}

export function TagCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tagName': !exists(json, 'tagName') ? undefined : json['tagName'],
    };
}

export function TagCreateRequestToJSON(value?: TagCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tagName': value.tagName,
    };
}


